import { StepEstateLetterToFinancialInstitutionMeta } from '@/modules/guidancestep/models/meta/shared/StepEstateLetterToFinancialInstitutionMeta';

export class Step426797Meta extends StepEstateLetterToFinancialInstitutionMeta {}
